import { Col, Row } from 'antd'

import { EditableInput } from '@eastcoal/common/components/EditableInput'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { OcrBusinessLicense } from '@eastcoal/shared/@formily/OcrBusinessLicense'
import { OcrIdCard } from '@eastcoal/shared/@formily/OcrIdCard'
import { OcrScene } from '@eastcoal/shared/enums/OcrScene'

export const businessLicenseSchema: Record<string, SchemaItem> = {
  [`
  { 
    ossId: licenseOssId, 
    result: {
        creditCode,
        companyName,
        companyType,
        businessScope,
        businessAddress,
        legalPerson,
        registeredCapital,
        validPeriod,
        RegistrationDate: registrationDate
      }
  }
  `]: {
    title: '营业执照',
    type: 'object',
    'x-validator': {
      triggerType: 'onInput',
      validator: async value => {
        if (!value) {
          return '请上传营业执照'
        }
        if (!value.result?.creditCode) {
          return '请上传有效的营业执照'
        }
        return null
      }
    },
    'x-decorator': FormItem,
    'x-decorator-props': {
      asterisk: true
    },
    'x-component': OcrBusinessLicense,
    'x-component-props': {
      scene: OcrScene.ENTERPRISE_AUDIT_LICENSE
    }
  },
  companyName: {
    title: '企业名称',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': EditableInput
  },
  creditCode: {
    title: '统一社会信用代码',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': EditableInput
  },
  legalPerson: {
    title: '法人',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': EditableInput
  },
  companyType: {
    title: '企业类型',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  businessAddress: {
    title: '企业住所',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  businessScope: {
    title: '经营范围',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': TextArea
  },
  registrationDate: {
    title: '成立日期',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  registeredCapital: {
    title: '实缴资本',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  validPeriod: {
    title: '营业期限',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  companyNameAbbr: {
    title: '企业简称',
    type: 'string',
    'x-decorator': FormItem,
    'x-component': Input
  },
  legalPersonRow: {
    title: '法人身份证',
    type: 'void',
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 'auto',
      asterisk: true,
      feedbackLayout: 'none'
    },
    'x-component': Row,
    'x-component-props': {
      gutter: 24
    },
    properties: {
      frontOcrCol: {
        type: 'void',
        'x-component': Col,
        properties: {
          [`
          {  
            ossId: legalPersonFrontOssId, 
            result: {
              name: legalPersonName,
              idNumber: legalPersonIdNumber
            }
          }
          `]: {
            type: 'object',
            'x-decorator': FormItem,
            'x-decorator-props': {
              wrapperWidth: 'auto'
            },
            'x-component': OcrIdCard.Front,
            'x-component-props': {
              width: 270,
              height: 150,
              scene: OcrScene.ENTERPRISE_AUDIT_LEGAL_PERSON_IDCARD_FRONT
            },
            'x-validator': {
              triggerType: 'onInput',
              validator: async value => {
                if (!value) {
                  return '请上传法人身份证人像面'
                }
                if (!value.result?.idNumber) {
                  return '请上传有效的法人身份证人像面'
                }
                return null
              }
            }
          }
        }
      },
      backOcrCol: {
        type: 'void',
        'x-component': Col,
        properties: {
          [`
          {
            ossId: legalPersonBackOssId,
            result: {
              issueAuthority: legalPersonIssueAuthority
            }
          }
          `]: {
            type: 'object',
            'x-decorator': FormItem,
            'x-decorator-props': {
              wrapperWidth: 'auto'
            },
            'x-component': OcrIdCard.Back,
            'x-component-props': {
              width: 270,
              height: 150,
              scene: OcrScene.ENTERPRISE_AUDIT_LEGAL_PERSON_IDCARD_BACK
            },
            'x-validator': {
              triggerType: 'onInput',
              validator: async value => {
                if (!value) {
                  return '请上传法人身份证国徽面'
                }
                if (!value.result?.issueAuthority) {
                  return '请上传有效的法人身份证国徽面'
                }
                return null
              }
            }
          }
        }
      }
    }
  },
  legalPersonName: {
    title: '法人姓名',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  },
  legalPersonIdNumber: {
    title: '法人身份证号',
    type: 'string',
    'x-pattern': 'readPretty',
    'x-decorator': FormItem,
    'x-component': Input
  }
}
